import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line

/*import LogoImage from "../../images/logo.svg";*/
import logo from "../../images/youngmindslogo.png";
import StartupLogo from "../../images/fixed-startup-india-logo.png";
import { components } from "ComponentRenderer.js";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";
import { ReactComponent as LinkedinIcon } from "../../images/linkedin-icon.svg";
import { Youtube, Facebook, Instagram, Linkedin } from "lucide-react";

const Container = tw.div`relative bg-[#131a22] -mb-8 px-8`;
const FiveColumns = tw.div`max-w-screen-xl mx-auto py-8 lg:py-10 lg:flex lg:flex-row justify-between xs:flex xs:flex-col`;

const Column = tw.div`mt-5 md:w-full lg:w-1/5 `;
const WideColumn = tw(
  Column
)`text-left md:text-left lg:w-1/4 md:w-2/5 mb-10 md:mb-0`;

const ColumnHeading = tw.h4`font-bold text-white`;

const LinkList = tw.ul`mt-4 text-sm font-medium list-none p-0 no-underline`;
const LinkListItem = tw.li`mt-3 no-underline`;
const Link = tw.a`no-underline text-white hocus:text-gray-300 transition duration-300`;
const LinkB = tw.a`ml-5 border-b-2 border-transparent text-white hocus:text-white hocus:border-white pb-1 transition duration-300 first:ml-0 `;
const LinkC = tw.a`border-b-2 border-transparent text-white hocus:text-blackStep-100 hocus:border-blackStep-100 pb-1 transition duration-300`;

const LogoContainer = tw.div`flex items-center justify-start md:justify-start`;

const AlIngenious = tw.h1`mt-2 text-lg font-bold text-white`;
const LogoImg = tw.img`w-1/2`;
const StartupImg = tw.img`w-1/2 py-4`;
const LogoText = tw.h5`ml-2 text-xl font-black text-primary-500`;

const CompanyDescription = tw.p`mt-4 max-w-xs font-medium text-sm mx-auto md:mx-0 md:mr-4 text-white`;

const SocialLinksContainer = tw.div`mt-4 ml-3`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block gap-4 p-2 rounded-full bg-linkedin text-gray-100 hover:bg-gray-900 transition duration-300 mr-4`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default ({
  landingPages = components.landingPages,
  innerPages = components.innerPages,
}) => {
  return (
    <Container>
      <FiveColumns>
        <WideColumn>
          <LogoContainer>
            <LogoImg
              src="https://pushsales.b-cdn.net/VAC%20Logo.png"
              className="aurum-logo"
            />
          </LogoContainer>
          <SocialLinksContainer>
            <ul
              className="header-info flex items-center"
              style={{ listStyle: "none", padding: 0, gap: "25px" }}
            >
              <li className="flex items-center gap-3">
                <a
                  href="https://www.youtube.com/@TaxwithoutTears"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Youtube style={{ marginRight: "10px", color: "#fff" }} />
                </a>

                <a
                  href="https://www.facebook.com/vagarwal123"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Facebook style={{ marginRight: "10px", color: "#fff" }} />
                </a>

                <a
                  href="https://www.instagram.com/cavijenderaggarwal"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Instagram style={{ marginRight: "10px", color: "#fff" }} />
                </a>

                <a
                  href="https://www.linkedin.com/in/ca-vijender-aggarwal-01836733a/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Linkedin style={{ marginRight: "0px", color: "#fff" }} />
                </a>
              </li>
            </ul>
          </SocialLinksContainer>
          <CompanyDescription></CompanyDescription>
        </WideColumn>
        <Column>
          <ColumnHeading>Our Products</ColumnHeading>
          <LinkList>
            <LinkListItem>
              <Link href="https://cavijenderaggarwal.com/products/?data=CA/CMA Inter Books">
                Books
              </Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="/">Video Lectures</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="https://cavijenderaggarwal.com/products/">
                Google Drive Classes
              </Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="https://cavijenderaggarwal.com/products/">
                Pen Drive Classes
              </Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="https://cavijenderaggarwal.com/products/">Android Classes</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="https://cavijenderaggarwal.com/products/">Live Classes</Link>
            </LinkListItem>
          </LinkList>
        </Column>

        <Column>
          <ColumnHeading>Company</ColumnHeading>
          <LinkList>
            <LinkListItem>
              <Link href={innerPages.aboutus.url}>About Us</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href={innerPages.blog.url}>Blogs</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href={innerPages.freevideo.url}>Free Videos</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href={innerPages.testimonial.url}>Testimonials</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href={innerPages.refundpolicy.url}>Refund Policy</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href={innerPages.privacypolicy.url}>Privacy Policy</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href={innerPages.termsandconditions.url}>
                Terms & Conditions
              </Link>
            </LinkListItem>
          </LinkList>
        </Column>
        <CompanyDescription>
          <ColumnHeading style={{ paddingBottom: "10px", fontSize: "16px" }}>
            Connect With Us
          </ColumnHeading>
          {/* <StartupImg src={StartupLogo} className="" /> */}
          Address : U-110, Ground Floor, <br />
          Vikas Marg, Near Laxmi Nagar Metro Station, Shakarpur, Delhi – 110092
          <br />
          <br />
          <strong>Helpline No.:</strong> +91-8920334084
        </CompanyDescription>
      </FiveColumns>
    </Container>
  );
};
